import { HOME_BLOCK_ITEMS_PER_ROW } from '~/shared/constants/home-block.constants';

export const ITEMS_PER_ROW = HOME_BLOCK_ITEMS_PER_ROW;
